import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router";
import { useSmartNavigate } from "@/hooks";
import { Breadcrumb } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import { getMenus } from "@/services";
import {
  getEffectivePagePath,
  findMenuTreeNodeAndParents,
  getPathWithoutSplats,
} from "@/utils";

export default function BreadCrumb() {
  const location = useLocation();
  const { "*": stackPath } = useParams();
  const path = getPathWithoutSplats(location.pathname, stackPath);
  const pagePath = getEffectivePagePath(path); // 获取有效的低码页面path
  const navigate = useSmartNavigate();
  const [breadItems, setBreadItems] = useState([]);

  // 通过约定的 url 路由后缀 判断当前页面类型
  // TODO: 是否需要显示额外的面包屑项
  // switch (path.replace(pagePath, "")) {
  //   case "/result":
  //     // 表单结果页
  //     // console.log("结果页");
  //     break;
  //   case "/update":
  //     // 表单编辑页
  //     // console.log("编辑页");
  //     break;
  //   case "/detail":
  //     // 表单详情页
  //     // console.log("详情页");
  //     break;
  //   default:
  //     break;
  // }

  useEffect(() => {
    const getBreadItem = async () => {
      const { menus: menuData } = await getMenus();
      const result = findMenuTreeNodeAndParents(menuData, pagePath); // 获取当前选中节点的所有父节点
      // 处理当前菜单选中项及面包屑
      if (result) {
        const currentBread = result.parents.map(({ label }) => {
          return { title: label };
        });
        setBreadItems([
          {
            title: <HomeOutlined />,
            href: "", // 只是为了触发ui选中效果
            onClick: (e) => {
              e.preventDefault();
              navigate("/");
            },
          },
          ...currentBread,
          { title: result.node.label },
        ]);
      } else {
        setBreadItems([
          {
            title: <HomeOutlined />,
            href: "", // 只是为了触发ui选中效果
            onClick: (e) => {
              e.preventDefault();
              navigate("/");
            },
          },
        ]);
      }
    };
    getBreadItem();
  }, [pagePath]);

  return <Breadcrumb items={breadItems} />;
}
